import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useField, useForm } from 'react-final-form';

import Checkbox from '../../../../../Checkbox/Checkbox';
import BirthName from '../BirthName/BirthName';

import { TXTWCL_My_last_name_at_birth_is_diffe_ELL } from './LegalNameExtendedDe.messages.json';
import { deExtendedNameFields } from './LegalNameExtendedDe.scss';

const LegalNameExtendedDe: React.FC = () => {
  const {
    input: { value: birthName }
  } = useField('birthName', { subscription: { value: true } });
  const [isChecked, setIsChecked] = useState(!!birthName);
  const form = useForm();
  const onChangeHandler = () => {
    setIsChecked(!isChecked);
    form.change('birthName', '');
  };

  return (
    <div className={deExtendedNameFields}>
      <Checkbox
        checked={isChecked}
        onChange={onChangeHandler}
        label={<Translation {...TXTWCL_My_last_name_at_birth_is_diffe_ELL} />}
      />
      {isChecked && <BirthName />}
    </div>
  );
};

export default LegalNameExtendedDe;
